import { isValidHexColor } from "@redotech/util/color";

/**
 * Forward the merchant's configured loading background to the embedded-tracking
 * iframe as a `loadingBg` URL param, so the return-app shell can paint it before
 * React hydrates. The iframe is served as static HTML from the CDN (not through
 * the ingress), so the server-side `<style>` injection never runs on this path.
 *
 * Only a clean 3- or 6-digit hex literal is forwarded (with the leading "#"
 * stripped for the param value); anything else (named colors, `rgb(...)`,
 * malformed or trailing-whitespace values) yields no param, leaving the default
 * white background.
 */
export function buildLoadingBgParam(
  loadingBg: string | null | undefined,
): string {
  if (!loadingBg || !isValidHexColor(loadingBg)) {
    return "";
  }
  return `&loadingBg=${loadingBg.replace(/^#/, "")}`;
}
